import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The inline link — brick, underlined. The only place `--link` is spent.
 *
 * With an `href` it is React Aria's `Link`, which means a client-side navigation goes
 * through the app's router (the root `RouterProvider`) while the element stays a real `<a>`
 * with a real URL — middle-click, copy-link and open-in-new-tab all keep working. Without
 * one it is a `Button` that looks like a link: the design's own pattern for "review",
 * "back to your library", and friends.
 */
import { Button as AriaButton, Link as AriaLink } from 'react-aria-components';
export function TextLink(props) {
    if (props.href !== undefined) {
        const { children, ...rest } = props;
        return (_jsx(AriaLink, { ...rest, className: "link", children: children }));
    }
    const { children, type = 'button', ...rest } = props;
    return (_jsx(AriaButton, { ...rest, type: type, className: "link", children: children }));
}
//# sourceMappingURL=TextLink.js.map